module.exports = __webpack_public_path__ + "images/006e8d4ecde3b18af311c7ea53c019b8-oops.png";